var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStorageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 27,
    viewBox: "0 0 15 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.61523,
    y: 6.34937,
    width: 12.6641,
    height: 1.15128,
    fill: "#808080"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.11391 1.55015L1.11391 24.9355C1.11391 24.9355 1.05198 25.9205 2.16021 25.9205H13.0079C13.0079 25.9205 13.9857 25.9577 13.901 24.8983V1.55015C13.901 1.55015 13.7673 1 12.3918 1H1.8473C1.8473 1 1.11391 1 1.11391 1.55015Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97256 9.93152H7.31668C7.16983 9.93152 7.05078 10.0992 7.05078 10.3061V12.1621C7.05078 12.3689 7.16983 12.5366 7.31668 12.5366H7.97256C8.11941 12.5366 8.23846 12.3689 8.23846 12.1621V10.3061C8.23846 10.0992 8.11941 9.93152 7.97256 9.93152Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorageIcon);
export default __webpack_public_path__ + "static/media/storage-icon.8e6613fac9221603d2fce343def7ebc9.svg";
export { ForwardRef as ReactComponent };